export default "__VITE_ASSET__DAF6hi$e__"